import { render, staticRenderFns } from "./FriendStatus.vue?vue&type=template&id=0d4654eb&"
import script from "./FriendStatus.vue?vue&type=script&lang=js&"
export * from "./FriendStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports